import { useCallback } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { Hotkey } from 'config/enums';
import { useAppDispatch } from 'features/app/hooks';
import { useTrackedInteractionAction } from 'features/analytics/hooks';
import { toggleLocalVideo } from 'features/local-video/store';

export const useSelfViewHotkey = () => {
  const dispatch = useAppDispatch();

  const onToggleSelfView = useCallback(() => {
    dispatch(toggleLocalVideo());
  }, [dispatch]);

  const { onActionHotkey } = useTrackedInteractionAction({
    actionName: 'self-view-settings-toggle',
    methodName: 'onInterpreterVideoButtonChange',
    eventName: 'NavbarInteraction',
  });

  useHotkeys(
    Hotkey.SelfView,
    () => {
      onToggleSelfView();
      onActionHotkey();
    },
    [onActionHotkey, onToggleSelfView],
    {
      enableOnFormTags: ['input', 'select', 'textarea'],
    }
  );
};
